import { nextTick } from 'vue';
import type { Ref } from 'vue';

export function useChatScroll(containerRef: Ref) {
  async function scrollToBottom(): Promise<void> {
    await nextTick();
    const el = containerRef.value;
    if (!el) return;
    const target = el.$el ?? el;
    // Support both Ionic ion-content (scrollToPoint) and plain div (scrollTop)
    if (typeof target.scrollToPoint === 'function') {
      target.scrollToPoint(undefined, target.scrollHeight + 10000, 100);
    } else {
      target.scrollTop = target.scrollHeight;
    }
  }
  return { scrollToBottom };
}
